import type { IStore } from '@inter-ikea-kompis/types';

import ServiceFetch from '../../utilities/ServiceFetch.js';
import IowsStoreTransformer from './IowsStoreTransformer.js';

/**
 * This class is used for fetching and parsing store data for IRW.
 */
export default class IowsStoreService {
	private readonly consumer: string;
	private readonly contract: string;
	private readonly endpoint: string;

	/**
	 * Constructor.
	 *
	 * @param options Options.
	 * @param options.consumer Consumer.
	 * @param options.contract Contract.
	 * @param options.endpoint Endpoint.
	 */
	constructor(options: { consumer: string; contract: string; endpoint: string }) {
		this.consumer = options.consumer;
		this.contract = options.contract;
		this.endpoint = options.endpoint;
	}

	/**
	 * Fetches and returns stores.
	 *
	 * @returns Promise object.
	 */
	public async getStores(): Promise<IStore[]> {
		const transformer = new IowsStoreTransformer();
		const response = await ServiceFetch.json(this.endpoint, {
			credentials: 'same-origin',
			headers: {
				accept: 'application/vnd.ikea.irms+json; version=2',
				'auth-token': this.consumer + '-' + this.contract,
				contract: this.contract,
				consumer: this.consumer
			}
		});
		return <IStore[]>transformer.transform(response);
	}
}
